import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export const ConfirmationModal = ({
	open,
	onClose,
	onConfirm,
}: {
	open: boolean;
	onClose(): void;
	onConfirm(): void;
}) => {
	const handleClose = () => {
		onClose();
	};

	return (
		<React.Fragment>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{'Claim'}</DialogTitle>

				<DialogContent>
					<DialogContentText
						id="alert-dialog-description"
						fontSize={14}
						fontFamily={'Roboto Mono'}
					>
						Are you sure you want to claim the deposit amount?
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button
						onClick={handleClose}
						style={{ fontFamily: 'Roboto Mono' }}
					>
						Cancel
					</Button>
					<Button
						onClick={onConfirm}
						autoFocus
						style={{ fontFamily: 'Roboto Mono' }}
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};
